import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Select from 'react-select';
import ReactSelect from '../../../components/ReactSelect';
import Billing from './UserInformation/billing';
import { createPaymentMethodsQuery } from '../../ChangePlanCustom/query';
import { showMessage } from '../../../helpers/showMessage';

class EditCard extends React.Component {
    constructor(props) {
        super();
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onChangeInfo = this.onChangeInfo.bind(this);
        this.onAddNewCard = this.onAddNewCard.bind(this);
        this.onChangeToggle = this.onChangeToggle.bind(this);

        this.state = {
            selected_payment_method:
                props.payment_methods?.find((item) => item.is_default)?.id ?? null,
            addNewCard: false,
            payment_methods: props.payment_methods ?? [],
            data: {
                cardholder_name: '',
                email: '',
            },
        };
    }

    componentDidUpdate(prevProps) {
        if (
            JSON.stringify(prevProps.payment_methods) !== JSON.stringify(this.props.payment_methods)
        ) {
            const defaultOne = this.props.payment_methods?.find((item) => item.is_default);
            this.setState({
                selected_payment_method: defaultOne?.id,
                payment_methods: this.props.payment_methods,
            });
            this.props.updatePaymentMethodId(defaultOne?.id);
        }
    }

    onChangeSelect(selected) {
        if (selected.expired) return;
        this.setState({ selected_payment_method: selected.value });
        this.props.updatePaymentMethodId(selected.value);
    }

    onChangeToggle = () => {
        this.setState((prevState) => ({
            addNewCard: !prevState.addNewCard,
        }));
    };

    onChangeInfo(e) {
        const field = e.target.name;
        const value = e.target.value;
        const newData = { ...this.state.data };
        newData[field] = value;
        const errors = { ...this.state.errors };
        delete errors?.[field];
        this.setState({ data: newData, errors });
        this.props.onChangeUserInfo(field, value);
    }

    async onAddNewCard(data) {
        try {
            const body = {
                token: data.payment_method,
                set_as_default: data.set_as_default || false,
            };
            const response = await createPaymentMethodsQuery(body);
            const dataRes = await response.json();
            if (response.status === 201) {
                this.setState({
                    payment_methods: dataRes?.is_default
                        ? [
                              ...this.state.payment_methods?.map((item) => ({
                                  ...item,
                                  is_default: false,
                              })),
                              dataRes,
                          ]
                        : [...this.state.payment_methods, dataRes],
                    selected_payment_method: dataRes?.id ?? null,
                    addNewCard: false,
                });
                this.props.updatePaymentMethodId(dataRes?.id ?? null);
            } else {
                showMessage('error', dataRes?.message ?? 'Something went wrong');
            }
        } catch (err) {
            showMessage('error', err?.message ?? 'Something went wrong');
        }
    }

    render() {
        const { t } = this.props;

        const optionList =
            this.state.payment_methods?.map((item) => ({
                value: item.id,
                expired: item.expired,
                label: (
                    <span
                        className="change-plan-crad"
                        style={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                        <span>
                            **** **** **** {item.last4}{' '}
                            {item.is_default && (
                                <span className="default-selected">{t('change_plan.default')}</span>
                            )}
                        </span>
                        {item.expired && (
                            <div className="d-flex align-items-start">
                                <span className="default-selected expired" title="Expired">
                                    {t('change_plan.expired')}
                                </span>
                            </div>
                        )}
                    </span>
                ),
            })) ?? [];

        const hasPaymentMethods = this.state.payment_methods?.length > 0;
        const showNewCardForm = !hasPaymentMethods || this.state.addNewCard;

        const label = (
            <div>
                Choose Existing Payment Method
                <div className="custom-registration-edit-card-add-new-wrapper">
                    <div className="d-flex align-items-center">
                        Or add New
                        <button onClick={this.onChangeToggle}>
                            <span
                                className={`switch-button  without-text ml-10 ${
                                    this.state.addNewCard ? 'active' : 'not-active'
                                }`}
                            >
                                <span className="switch-circle" />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        );
        return (
            <div className="custom-registration-body-step">
                <div className="custom-registration-body-step-header">
                    <span>{this.props.step ?? 4}</span> Card Details
                </div>
                <div className="custom-registration-body-step-body">
                    <div className="custom-registration-edit-card">
                        {hasPaymentMethods && (
                            <ReactSelect
                                options={[...optionList]}
                                customeOnChange={this.onChangeSelect}
                                value={optionList.find(
                                    (x) => x.value === this.state.selected_payment_method,
                                )}
                                classname="w-100"
                                disabled={this.state.addNewCard}
                                isSearchable={true}
                                blurInputOnSelect={true}
                                label={label}
                                hideSelect={this.state.addNewCard}
                            />
                        )}
                        {showNewCardForm && (
                            <div className="custom-registration-user-information">
                                <Billing
                                    previous={this.previous}
                                    onChangeInfo={this.onChangeInfo}
                                    cardholder_name={this.state.data.cardholder_name}
                                    email={this.state.data.email}
                                    createRequestBody={this.onAddNewCard}
                                    isEdit
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(EditCard);
